export const LOAD_CHUNK_VIEW_SIGNAL = 'edrolo/lessons/LOAD_CHUNK_VIEW_SIGNAL';

export const LOAD_LESSON_BY_LESSON_ID_SIGNAL =
  'edrolo/lessons/LOAD_LESSON_BY_LESSON_ID_SIGNAL';
export const LOAD_LESSON_BY_LESSON_ID_REQUEST =
  'edrolo/lessons/LOAD_LESSON_BY_LESSON_ID_REQUEST';
export const LOAD_LESSON_BY_LESSON_ID_SUCCESS =
  'edrolo/lessons/LOAD_LESSON_BY_LESSON_ID_SUCCESS';
export const LOAD_LESSON_BY_LESSON_ID_FAILURE =
  'edrolo/lessons/LOAD_LESSON_BY_LESSON_ID_FAILURE';

export const LOAD_COURSE_BY_LESSON_ID_SIGNAL =
  'edrolo/lessons/LOAD_COURSE_BY_LESSON_ID_SIGNAL';
export const LOAD_COURSE_BY_LESSON_ID_REQUEST =
  'edrolo/lessons/LOAD_COURSE_BY_LESSON_ID_REQUEST';
export const LOAD_COURSE_BY_LESSON_ID_SUCCESS =
  'edrolo/lessons/LOAD_COURSE_BY_LESSON_ID_SUCCESS';
export const LOAD_COURSE_BY_LESSON_ID_FAILURE =
  'edrolo/lessons/LOAD_COURSE_BY_LESSON_ID_FAILURE';

export const LOAD_QUIZ_STATS_BY_LESSON_ID_SIGNAL =
  'edrolo/lessons/LOAD_QUIZ_STATS_BY_LESSON_ID_SIGNAL';
export const LOAD_QUIZ_STATS_BY_LESSON_ID_REQUEST =
  'edrolo/lessons/LOAD_QUIZ_STATS_BY_LESSON_ID_REQUEST';
export const LOAD_QUIZ_STATS_BY_LESSON_ID_SUCCESS =
  'edrolo/lessons/LOAD_QUIZ_STATS_BY_LESSON_ID_SUCCESS';
export const LOAD_QUIZ_STATS_BY_LESSON_ID_FAILURE =
  'edrolo/lessons/LOAD_QUIZ_STATS_BY_LESSON_ID_FAILURE';

export const LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_SIGNAL =
  'edrolo/lessons/LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_SIGNAL';
export const LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_REQUEST =
  'edrolo/lessons/LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_REQUEST';
export const LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_SUCCESS =
  'edrolo/lessons/LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_SUCCESS';
export const LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_FAILURE =
  'edrolo/lessons/LOAD_QUIZ_ATTEMPTS_BY_LESSON_ID_FAILURE';

export const SAVE_QUIZ_ATTEMPT_SIGNAL =
  'edrolo/lessons/SAVE_QUIZ_ATTEMPT_SIGNAL';
export const SAVE_QUIZ_ATTEMPT_REQUEST =
  'edrolo/lessons/SAVE_QUIZ_ATTEMPT_REQUEST';
export const SAVE_QUIZ_ATTEMPT_SUCCESS =
  'edrolo/lessons/SAVE_QUIZ_ATTEMPT_SUCCESS';
export const SAVE_QUIZ_ATTEMPT_FAILURE =
  'edrolo/lessons/SAVE_QUIZ_ATTEMPT_FAILURE';

export const LOAD_CHUNK_VISITS_BY_LESSON_ID_SIGNAL =
  'edrolo/lessons/LOAD_CHUNK_VISITS_BY_LESSON_ID_SIGNAL';
export const LOAD_CHUNK_VISITS_BY_LESSON_ID_REQUEST =
  'edrolo/lessons/LOAD_CHUNK_VISITS_BY_LESSON_ID_REQUEST';
export const LOAD_CHUNK_VISITS_BY_LESSON_ID_SUCCESS =
  'edrolo/lessons/LOAD_CHUNK_VISITS_BY_LESSON_ID_SUCCESS';
export const LOAD_CHUNK_VISITS_BY_LESSON_ID_FAILURE =
  'edrolo/lessons/LOAD_CHUNK_VISITS_BY_LESSON_ID_FAILURE';

export const RECORD_CHUNK_VISIT_SIGNAL =
  'edrolo/lessons/RECORD_CHUNK_VISIT_SIGNAL';
export const RECORD_CHUNK_VISIT_REQUEST =
  'edrolo/lessons/RECORD_CHUNK_VISIT_REQUEST';
export const RECORD_CHUNK_VISIT_SUCCESS =
  'edrolo/lessons/RECORD_CHUNK_VISIT_SUCCESS';
export const RECORD_CHUNK_VISIT_FAILURE =
  'edrolo/lessons/RECORD_CHUNK_VISIT_FAILURE';

// Action types for success measure responses
export const LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_SIGNAL =
  'edrolo/lessons/LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_SIGNAL';
export const LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_REQUEST =
  'edrolo/lessons/LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_REQUEST';
export const LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_SUCCESS =
  'edrolo/lessons/LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_SUCCESS';
export const LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_FAILURE =
  'edrolo/lessons/LOAD_SUCCESS_MEASURE_RESPONSES_BY_LESSON_ID_FAILURE';

export const RECORD_SUCCESS_MEASURE_RESPONSE_SIGNAL =
  'edrolo/lessons/RECORD_SUCCESS_MEASURE_RESPONSE_SIGNAL';
export const RECORD_SUCCESS_MEASURE_RESPONSE_REQUEST =
  'edrolo/lessons/RECORD_SUCCESS_MEASURE_RESPONSE_REQUEST';
export const RECORD_SUCCESS_MEASURE_RESPONSE_SUCCESS =
  'edrolo/lessons/RECORD_SUCCESS_MEASURE_RESPONSE_SUCCESS';
export const RECORD_SUCCESS_MEASURE_RESPONSE_FAILURE =
  'edrolo/lessons/RECORD_SUCCESS_MEASURE_RESPONSE_FAILURE';
